export default __webpack_public_path__ + "static/media/sidebar_sim_gray.7e422819.svg";